import { post,get,del,put } from '@/utils/request'

// 新增教师
export function addTeacher(data) {
  return post('/manage/teacher', data)
}

// 获取教师列表
export function getTeacherList() {
  return get('/teacher')
} 

// 获取教师列表
export function getTeacherDetail(id) {
  return get(`/teacher/${id}`)
} 

// 获取教师列表
export function deleteTeacher(id) {
    return del(`/manage/teacher/${id}`)
  } 
  
// 获取教师列表
export function updateTeacher(id,data) {
    return put(`/manage/teacher/${id}`,data)
  }

// 获取教师列表
export function updateTeacherOrder(data) {
    return put(`/manage/teacherSort`,data)
  }